module.exports = __webpack_public_path__ + "static/media/product.b0ca7d99.jpg";